<script>
import { layoutComputed } from "@/state/helpers";
import Layout from "../layouts/main";
import { menuItems } from "./data";
import Heading from "../layouts/heading.vue";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import api from "../../api";

export default {
  page: {
    title: "Practice",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Heading,
  },
  data() {
    return {
      page: {
        title: "Practice",
        lastUpdated: false,
        addNewBtn: false,
        addNewModalTitle: "Create New Page",
        formData: {},
        schema: {
          name: {
            type: "text",
            label: "Name",
            placeholder: "Enter Name",
            required: true,
            info: false,
            character_count: 50,
          },
          icon: {
            type: "text",
            label: "Icon",
            placeholder: "Enter Icon Class",
            required: false,
            info: false,
            character_count: 0,
          },
          link: {
            type: "text",
            label: "link",
            placeholder: "Enter Link",
            required: true,
            info: false,
            character_count: 0,
          },
        },
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
      },
      menuItems: menuItems,
      categories: [],
      allCategories: [],
    };
  },
  computed: {
    ...layoutComputed,
  },
  methods: {
    initializeCategories() {
      const baseCategories = [
        {
          type: "Home",
          items: [
            {
              name: "Landing Page",
              icon: "landingpage.svg",
              status: "",
            },
            {
              name: "Quick Links",
              icon: "quicklinks.svg",
              status: "",
            },
            {
              name: "Health | Wellbeing",
              icon: "health_wellbeing.svg",
              status: "coming_soon",
            },
            {
              name: "Recommend. Apps",
              icon: "recommendedapps.svg",
              status: "",
            },
            {
              name: "Practice Info.",
              icon: "jointhepractice.svg",
              status: "",
            },
            {
              name: "PCN Info.",
              icon: "pcn-info.svg",
              status: "",
            },
            // {
            //     "name": "PCN Information",
            //     "icon": "whatisapcn.svg",
            //     "status": "coming_soon"
            // },
            {
              name: "Footer",
              icon: "footer.svg",
              status: "",
            },
            {
              name: "Health Campaigns",
              icon: "pcn-info.svg",
              status: "coming_soon",
            },
          ],
        },
        {
          type: "Dropdown Menus",
          items: [
            {
              name: "Reception Enquiries",
              icon: "reception.svg",
              status: "",
            },
            {
              name: "Manage Condition",
              icon: "cronic-disease.svg",
              status: "",
            },
            {
              name: "About Us",
              icon: "aboutus.svg",
              status: "",
            },
            {
              name: "Health & Wellbeing",
              icon: "health_wellbeing.svg",
              status: "",
            },
            {
              name: "Online Forms",
              icon: "documents.svg",
              status: "",
            },
            {
              name: "Practice Policies",
              icon: "practice-pol.svg",
              status: "coming_soon",
            },
          ],
        },
        {
          type: "Patient Communication",
          items: [
            {
              name: "Patient News",
              icon: "news.svg",
              status: "",
            },
            {
              name: "Alerts",
              icon: "alerts.svg",
              status: "",
            },
            {
              name: "Banners",
              icon: "banners.svg",
              status: "coming_soon",
            },
          ],
        },
        {
          type: "Pages",
          items: [
            {
              name: "Join the Practice",
              icon: "jointhepractice.svg",
              status: "",
            },
            // {
            //   name: "Appointments",
            //   icon: "appointments.svg",
            //   status: "coming_soon",
            // },
            {
              name: "Prescriptions",
              icon: "prescription.svg",
              status: "",
            },
            {
              name: "Sick/Fit Notes",
              icon: "sicknotes.svg",
              status: "",
            },
            {
              name: "Tests & Results",
              icon: "tests_results.svg",
              status: "",
            },
            {
              name: "Clinics & Services",
              icon: "clinics_and_services.svg",
              status: "",
            },
            {
              name: "Carer Information",
              icon: "carer_info.svg",
              status: "",
            },
            {
              name: "Patient Group",
              icon: "patientgroup.svg",
              status: "",
            },
            // {
            //     "name": "Self Referrals",
            //     "icon": "self_referrals.svg",
            //     "status": "coming_soon"
            // },
            {
              name: "Feedback",
              icon: "feedback.svg",
              status: "",
            },
            {
              name: "Online Services",
              icon: "online_services.svg",
              status: "",
            },
            {
              name: "Info Pages",
              icon: "pages.svg",
              status: "",
            },
            {
              name: "Non NHS Fees",
              icon: "nonnhsfees.svg",
              status: "",
            },
            {
              name: "Community Wellbeing",
              icon: "customer-support.svg",
              status: "beta",
            },
            {
              name: "Cancel Appointments",
              icon: "cancel-appointments.svg",
              status: "beta",
            },
            {
              name: "Book Appointments",
              icon: "cancel-appointments.svg",
              status: "beta",
            },
            {
              name: "Self Referrals",
              icon: "self_referral.svg",
              status: "beta",
            },
          ],
        },
        // {
        //     "type": "Patient Navigation",
        //     "items": [
        //         {
        //             "name": "Contact Us",
        //             "icon": "contactus.svg",
        //             "status": "coming_soon"
        //         },
        //         {
        //             "name": "Common Ailments",
        //             "icon": "common_ailments.svg",
        //             "status": "coming_soon"
        //         }
        //     ]
        // },
        {
          type: "Staff Management",
          items: [
            {
              name: "Practice Team",
              icon: "practice_team.svg",
              status: "",
            },
            {
              name: "Staff Availability",
              icon: "staff-availability.svg",
              status: "",
            },
            {
              name: "Job Vacancies",
              icon: "job-vacancies.svg",
              status: "",
            },
          ],
        },
        {
          type: "Documents Management",
          items: [
            {
              name: "Documents",
              icon: "documents.svg",
              status: "",
            },
          ],
        },
        {
          type: "Practice Settings",
          items: [
            {
              name: "General",
              icon: "general.svg",
              status: "",
            },
            {
              name: "Locations",
              icon: "location.svg",
              status: "",
            },
            {
              name: "Opening Hours",
              icon: "opening_hours.svg",
              status: "",
            },
            // {
            //     "name": "CQC Rating",
            //     "icon": "cqc.svg",
            //     "status": ""
            // },
            {
              name: "Social Media",
              icon: "social_media.svg",
              status: "",
            },
            {
              name: "Mail Settings",
              icon: "mail_settings.svg",
              status: "",
            },
          ],
        },
        {
          type: "App Integrations",
          items: [
            {
              name: "Healthier Together",
              icon: "healthier_together.png",
              status: "",
            },
            {
              name: "Patchs",
              icon: "patchs.svg",
              status: "",
            },
            {
              name: "Anima",
              icon: "anima.png",
              status: "",
            },
            // {
            //     "name": "Get U better",
            //     "icon": "get_u_better.png",
            //     "status": "coming_soon"
            // },
            // {
            //     "name": "EConsult",
            //     "icon": "econsult.svg",
            //     "status": "coming_soon"
            // },
            // {
            //     "name": "Patient Assist",
            //     "icon": "patientassist.svg",
            //     "status": "coming_soon"
            // },
            {
              name: "Patient Voice",
              icon: "patient-voice.svg",
              status: "",
            },
            {
              name: "Patient Assist",
              icon: "patient-assist.svg",
              status: "",
            },
            {
              name: "Rapid Health",
              icon: "rapidhealth.svg",
              status: "",
            },
          ],
        },
      ];

      // Filter out specific categories for Oaks Healthcare
      if (this.currentPractice && this.currentPractice.name === "Oaks Healthcare") {
        return baseCategories.map(category => {
          if (category.type === "Dropdown Menus") {
            return {
              ...category,
              items: category.items.filter(item =>
                item.name !== "Manage Condition" &&
                item.name !== "About Us" &&
                item.name !== "Health & Wellbeing"
              )
            };
          } else if (category.type === "Pages") {
            return {
              ...category,
              items: category.items.filter(item =>
                item.name !== "Non NHS Fees" &&
                item.name !== "Community Wellbeing"
              )
            };
          } else if (category.type === "Home") {
            return {
              ...category,
              items: category.items.filter(item =>
                item.name !== "Health Campaigns"
              )
            };
          }
          return category;
        });
      }

      return baseCategories;
    },
    create(val) {
      if (val) {
        var data = {
          uuid: uuidv4(),
          name: val.name,
          creationDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          cmsId: this.currentCms.id,
          fields: {},
          additionalProp1: {
            icon: val.icon,
            link: val.link,
          },
        };
        api.post("/api/categories", data).then(
          () => {
            // console.log(response);
            Swal.fire("Page Created!", "Page Created Successfully!", "success");
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    // In your component
    getDisplayName(name) {
      const abbreviations = {
        "Community Wellbeing": "Comm. Wellbeing",
        "Book Appointments": "Book Appoint.",
        "Cancel Appointments": "Cancel Appoint.",
      };
      return abbreviations[name] || name;
    },
    getCategories() {
      if (this.currentCms && this.currentCms.id) {
        var url = "/api/cms/" + this.currentCms.id + "/categories";
        api
          .get(url)
          .then((response) => {
            var objIndex = response.data.findIndex(
              (obj) => obj.name == "Pages (Footer)"
            );
            if (objIndex != -1) {
              response.data[objIndex].name = "Info Pages";
            }
            this.categories = response.data;
          })
          .catch((e) => {
            this.categories = [];
            console.log(e);
          });
      }
    },
    updateCurrentCategory(item) {
      let check;
      if (item.name == "Patient News") {
        check = this.categories.find((x) => x.name == "News");
      } else {
        check = this.categories.find((x) => x.name == item.name);
      }
      this.$store.commit("updateCurrentCategory", check);
    },
    categoryExists(item) {
      let check = false;
      if (item.name == "Patient News") {
        check = this.categories.find((x) => x.name == "News");
      } else {
        check = this.categories.find((x) => x.name == item.name);
      }
      if (check) return true;
      return false;
    },
    getCategoryId(item) {
      let check;
      if (item.name == "Patient News") {
        check = this.categories.find((x) => x.name == "News");
      } else {
        check = this.categories.find((x) => x.name == item.name);
      }
      return check.id;
    },
    canShowtitle(name) {
      let practiceName = this.currentPractice.name;
      if (
        name === "App Integrations" &&
        (practiceName === "Everglade Medical Practice" ||
          practiceName === "Watling Medical Centre" ||
          practiceName === "Parkview Surgery" ||
          practiceName === "Medical Centre")
      ) {
        return false;
      }
      return true;
    },
    checkShow(item) {
      let practiceName = this.currentPractice.name;
      
      // Hide specific categories for Oaks Healthcare
      if (practiceName === "Oaks Healthcare" && 
          (item.name === "Manage Condition" || 
           item.name === "About Us" || 
           item.name === "Health & Wellbeing" ||
           item.name === "Community Wellbeing" ||
           item.name === "Non NHS Fees" ||
           item.name === "Health Campaigns")) {
        return false;
      }
      
      if (
        item.name === "Healthier Together" &&
        (practiceName === "Everglade Medical Practice" ||
          practiceName === "Watling Medical Centre" ||
          practiceName === "Parkview Surgery" ||
          practiceName === "Medical Centre")
      ) {
        return false;
      }
      if (item.status === "coming_soon" || item.status === "beta") {
        if (["Demo"].includes(this.currentPractice.name)) {
          return true;
        } else if (
          item.name.includes("About Us") &&
          ["Eynsham Medical Group"].includes(this.currentPractice.name)
        ) {
          return true;
        } else if (
          item.name.includes("Health & Wellbeing") &&
          ["The Phoenix Practice"].includes(this.currentPractice.name)
        ) {
          return true;
        } else {
          return (
            (item &&
              item.name &&
              (item.name.includes("Practice Info") ||
                item.name.includes("Reception Enquiries") ||
                item.name.includes("Manage Condition") ||
                item.name.includes("PCN Info.") ||
                item.name.includes("Landing Page") ||
                item.name.includes("Prescriptions") ||
                item.name.includes("Cancel Appointments") ||
                item.name.includes("Self Referrals") ||
                item.name.includes("Join the Practice") ||
                item.name.includes("Non NHS Fees") ||
                item.name.includes("Tests & Results") ||
                item.name.includes("General") ||
                item.name.includes("Feedback"))) ||
            item.name.includes("Community Wellbeing")
          );
        }
      }
      if (
        item.name == "Patchs" &&
        this.currentPractice.name != "Demo" &&
        this.currentPractice.name != "Farnham Dene Medical Practice"
      ) {
        return false;
      }
      if (item.name == "Anima") {
        if (
          this.currentPractice.name == "Demo" ||
          this.currentPractice.name == "Oakley Health Group" ||
          this.currentPractice.name == "Twyford Surgery" ||
           this.currentPractice.name == "Oaks Healthcare"
        ) {
          return true;
        }
        return false;
      } else if (
        item.name == "Patient Voice" ||
        item.name == "Patient Assist"
      ) {
        if (this.currentPractice.name == "Demo") {
          return true;
        }
        return false;
      } else if (item.name == "Rapid Health") {
        const practiceNames = [
          "Demo",
          "Station Road Surgery",
          "Park House Surgery",
          "Camberley Health Centre",
          "Bartlett Group Practice",
          "Park Road Group Practice",
          "Kineton Surgery",
          "Farnham Dene Medical Practice",
          "Upper Gordon Road Surgery",
          "Farnham Park Health Group",
          "Ringmead Medical Practice",
          "Mayfield Medical Centre",
        ];
        if (practiceNames.includes(this.currentPractice.name)) {
          return true;
          // Your code here
        }
        return false;
      }
      return true;
    },
  },
  watch: {
    currentCms() {
      this.getCategories();
    },
    currentPractice() {
      this.allCategories = this.initializeCategories();
    },
  },
  async mounted() {
    this.allCategories = this.initializeCategories();
    await this.getCategories();
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page" @created="create"></Heading>

    <div v-if="categories.length" class="mb-5">
      <div v-for="itemType in allCategories" v-bind:key="itemType.type">
        <div
          class="font-size-20 font-weight-medium pl-4 mt-4 ml-1"
          v-if="
            itemType.items &&
            itemType.items.length &&
            canShowtitle(itemType.type, itemType.items)
          "
        >
          {{ itemType.type }}
        </div>
        <div class="row mt-4" style="letter-spacing: 0.02em">
          <div
            v-show="checkShow(item)"
            class="col-md-2"
            v-for="item in itemType.items"
            v-bind:key="item.name"
          >
            <div>
              <router-link
                v-if="item.name == 'Staff Availability'"
                :to="{ name: 'Staff Availability' }"
                class="text-dark"
              >
                <div class="card align-items-center">
                  <div class="card-body p-0">
                    <div class="text-primary font-size-50">
                      <img
                        :src="require(`@/assets/images/staff-availability.svg`)"
                      />
                    </div>
                  </div>
                  <div class="card-body p-0 pb-3 pt-2 text-center">
                    <p class="mx-auto text-uppercase m-0 font-weight-medium">
                      Staff Availability
                    </p>
                  </div>
                </div>
              </router-link>
              <router-link
                v-else-if="categoryExists(item)"
                :to="{
                  name: 'Dynamic Category Page',
                  params: {
                    categoryId: getCategoryId(item),
                    cmsId: currentCms.id,
                    categoryName: item.name.replace(/ /g, '').toLowerCase(),
                  },
                }"
                @click="updateCurrentCategory(item)"
                class="text-dark"
              >
                <div class="card align-items-center">
                  <div
                    v-if="item.status == 'beta'"
                    class="w-100 mt-3"
                    style="margin-bottom: -2.5em; z-index: 1"
                  >
                    <span
                      class="p-1 px-2 text-light"
                      style="
                        background-color: #f28d00;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >BETA</span
                    >
                  </div>
                  <div
                    v-else-if="item.status == 'New'"
                    class="w-100 mt-3"
                    style="margin-bottom: -2.5em; z-index: 1"
                  >
                    <span
                      class="p-1 px-2 text-light"
                      style="
                        background-color: #da3f3f;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >NEW</span
                    >
                  </div>
                  <div
                    v-else-if="item.status == 'coming_soon'"
                    class="w-100 mt-3"
                    style="margin-bottom: -2.5em; z-index: 1"
                  >
                    <span
                      class="p-1 px-2 text-light"
                      style="
                        background-color: #333;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >COMING SOON</span
                    >
                  </div>
                  <div
                    v-else-if="item.status == 'new'"
                    class="w-100 mt-3"
                    style="margin-bottom: -2.5em; z-index: 1"
                  >
                    <span
                      class="p-1 px-2 text-light"
                      style="
                        background-color: #b60000;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >NEW</span
                    >
                  </div>
                  <div class="card-body p-0">
                    <div class="text-primary font-size-50">
                      <img
                        v-if="item.icon.endsWith('.png')"
                        :src="require(`@/assets/images/${item.icon}`)"
                        width="50px"
                      />
                      <img
                        v-else
                        :src="require(`@/assets/images/${item.icon}`)"
                      />
                    </div>
                  </div>
                  <div class="card-body p-0 pb-3 pt-2 text-center">
                    <p class="mx-auto text-uppercase m-0 font-weight-medium">
                      {{ getDisplayName(item.name) }}
                    </p>
                  </div>
                </div>
              </router-link>
              <a v-else class="text-dark">
                <div class="card align-items-center">
                  <div
                    v-if="item.status == 'beta'"
                    class="w-100 mt-3"
                    style="margin-bottom: -2.5em; z-index: 1"
                  >
                    <span
                      class="p-1 px-2 text-light"
                      style="
                        background-color: #f28d00;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >BETA</span
                    >
                  </div>
                  <div
                    v-else-if="item.status == 'coming_soon'"
                    class="w-100 mt-3"
                    style="margin-bottom: -2.5em; z-index: 1"
                  >
                    <span
                      class="p-1 px-2 text-light"
                      style="
                        background-color: #333;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >COMING SOON</span
                    >
                  </div>
                  <div
                    v-else-if="item.status == 'new'"
                    class="w-100 mt-3"
                    style="margin-bottom: -2.5em; z-index: 1"
                  >
                    <span
                      class="p-1 px-2 text-light"
                      style="
                        background-color: #b60000;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >NEW</span
                    >
                  </div>
                  <div class="card-body p-0">
                    <div class="text-primary font-size-50">
                      <img
                        v-if="item.icon.endsWith('.png')"
                        :src="require(`@/assets/images/${item.icon}`)"
                        width="50px"
                      />
                      <img
                        v-else
                        :src="require(`@/assets/images/${item.icon}`)"
                      />
                    </div>
                  </div>
                  <div class="card-body p-0 pb-3 pt-2 text-center">
                    <p class="mx-auto text-uppercase m-0 font-weight-medium">
                      {{ item.name }}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
